import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { DisplayInputComponent } from '@components';
import { Store } from '@ngrx/store';
import { UtilService } from '@services';
import {
  fetchCurrentServiceRequest,
  selectCurrentServiceRequest,
  selectServiceRequestsFetchedAt,
} from '@state/service-request';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    DisplayInputComponent,
    MatGridListModule,
  ],
  templateUrl: './service-request.page.html',
  styleUrl: './service-request.page.scss',
})
export class ServiceRequestPage implements OnInit {
  $serviceRequest = this.store.select(selectCurrentServiceRequest);
  $serviceRequestsFetchedAt = this.store.select(selectServiceRequestsFetchedAt);

  constructor(
    private store: Store,
    private router: Router,
    public utils: UtilService
  ) {}

  public ngOnInit(): void {
    this.store.dispatch(fetchCurrentServiceRequest());
  }

  public navToCustomerDetails(id: string): void {
    this.router.navigate([`/customers/${id}`]);
  }
}
